import { render, staticRenderFns } from "./AddWorkerAssignment.vue?vue&type=template&id=5175f594"
import script from "./AddWorkerAssignment.vue?vue&type=script&lang=js"
export * from "./AddWorkerAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports